<template>
    <div>
        <div class="d-sm-down-none">
            <CRow>
                <CCol sm="6" style="background-size: cover; display: flex; align-items: center; justify-content: center; min-height: 100vh;" class="bg-white">
                    <CContainer style="max-width: 600px; text-align: left;">
                        <div>
                            <h3 class="custom-32px-500 font-color-171717 text-left">Forgot Password</h3>
                            <p class="custom-18px-500">Enter your email and we'll send you instructions to <span class="font-color-928AFD">reset your password</span></p>
                        </div>
    
                        <div v-if="ErrorLogin" class="">
                            <CAlert show color="danger">
                                <strong class="text-danger mr-2">Error!</strong> {{ Message }}
                            </CAlert>
                        </div>
                        <div class="mt-5">
                            <strong class="text-left mt-2 mb-2 custom-14px-400 font-inter font-color-101010">Email</strong>
                            <input type="text" class="custom-input-app mb-2 mt-2" v-model="userEmail" />
                        </div>
                        <div style="clear:both"></div>
                        <div class="text-center ml-2">
                            <span v-if="lblProcess === true" class="font-color-101010 custom-16px-500">Processing....</span>
                            <br /> <br />
                            <span class="custom-border-purple p-2 text-center text-white" v-on:click="sendForgot">
                                                            <label class="ml-2 mr-2">Send Code</label></span>
                            <br />
                        </div>
    
                    </CContainer>
                </CCol>
    
                <CCol sm="6" lg="6" style="background-size: cover; background-position: center; min-height: 100vh;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
                    <CRow class="mt-3 p-3">
                        <CCol sm="6">
                            <img src="../assets/img/Logo(1).png" height="32" alt="Interviewrr.ai company logo" /> <span class="custom-20px-500 text-white">Interviewrr</span>
                        </CCol>
                        <CCol sm="6"></CCol>
                        <CCol sm="12">
                            <h3 class="custom-32px-700 text-white mt-5">Effortless e-Voucher Distribution</h3>
                            <p class="custom-18px-400 text-white">Easily generate and send personalized e-Vouchers automatically, encouraging customer engagement and repeat business with every interaction</p>
                        </CCol>
                    </CRow>
                </CCol>
    
            </CRow>
    
        </div>
        <div style="background-color: white; min-height: 100vh; padding-bottom: 20px;" class="d-md-none d-lg-none">
            <CContainer class="settings-container">
                <CButton color="link" class="back-button" @click="$router.go(-1)">
                    <CIcon name="cil-arrow-left" size="xl" />
                </CButton>
    
                <!-- Page Title -->
                <h2 class="title">Forgot Password</h2>
                <div v-if="ErrorLogin" class="text-left">
                    <CAlert show color="danger">
                        <strong class="text-danger mr-2">Error!</strong> {{ Message }}
                    </CAlert>
                </div>
                <div class="mt-5 text-left">
                    <strong class="text-left mt-2 mb-2 custom-14px-400 font-inter font-color-101010">Email</strong>
                    <input type="text" class="custom-input-app mb-2 mt-2" v-model="userEmail" />
                </div>
                <div style="clear:both"></div>
    
            </CContainer>
            <div class="text-center">
                <span v-if="lblProcess === true" class="font-color-101010 custom-16px-500">Processing....</span>
                <br /> <br />
                <CCol sm="12" class="p-2">
        <CButton class="custom-border-purple position-bottom" color="primary" block v-on:click="sendForgot">
            Continue
        </CButton>
        </CCol>
            </div>
        </div>
    
    
        <div v-if="isLanguagePopupVisible1" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100px" src="../assets/img/success.png" />
                    <h3 class="custom-32px-500">Success!</h3>
                    <h3 class="custom-18px text-center">Your account is succesfully registered</h3>
                    <CButton class="custom-border-purple text-white" @click="closePopup"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
    
            </div>
        </div>
    
    
    </div>
</template>

<script>
import Vue from "vue";

import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '1076578801027-kt1ptr3hd1ou78tlj65vmfaj8tgafq72.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)

import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgsecond.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            userEmail: "",
            lblProcess: false,
            isLanguagePopupVisible1:false





        };
    },


    methods: {
        sendForgot() {
            this.lblProcess = true;
            this.ErrorLogin = false;

            const formData = new FormData();

            if (this.userEmail === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                this.buttonLabel = 'Processing';
                formData.append("userEmail", this.userEmail);

                this.$API
                    .post(this.$ForgotPassword, formData)
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                        if (response.status == 200) {

                            if (response.status !== 400) {


                                this.$router.push("Verifypassword?email=" + this.userEmail);

                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.ErrorLogin = true;
                            }
                        } else {
                            this.Loading = false;
                            this.ErrorLogin = true;
                            this.Message = response.data.message;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                    });
            }
        },



    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
.position-bottom {
  position: fixed;
  bottom: 20px;
  width: 96%;
  z-index: 1000;
  text-align: center;
  padding: 10px;
}
</style>